import React, { useEffect, useState } from "react";
import "./SaveModal.scss";

const SaveModal = ({ isOpen, onClose, onSave, title }) => {
  const [newArea, setNewArea] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setNewArea("");
    }
  }, [isOpen]);

  const handleSave = (e) => {
    e.preventDefault();
    if (newArea.trim()) {
      onSave(newArea);
      setNewArea("");
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="SaveModal">
      <div className="save-modal-backdrop" onClick={onClose} />
      <div className="modal-container" role="dialog" aria-modal="true" aria-labelledby="save-modal-title">
        <button className="close-button" onClick={onClose}>
          <span className="close-icon" />
        </button>
        <form onSubmit={handleSave}>
          <p className="modal-eyebrow">Novo item</p>
          <h2 className="modal-title" id="save-modal-title">
            {title ? title : "Digite o nome da nova area"}
          </h2>
          <p className="modal-description">
            Adicione um novo valor para disponibilizar essa opcao no formulario.
          </p>
          <input
            type="text"
            className="modal-input"
            value={newArea}
            onChange={(e) => setNewArea(e.target.value)}
            placeholder="Nova area"
            autoFocus
          />
          <button className="save-button" type="submit" disabled={!newArea.trim()}>
            SALVAR <span className="fa6-solid--arrow-right" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default SaveModal;
